import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import { obtenerPremiosUsuario, reclamarPremioDiario } from '../services/userService';

const PremiosUsuario = () => {
 const { user, loading } = useUser();
  const [premiosData, setPremiosData] = useState(null);
  const [loadingPremios, setLoadingPremios] = useState(true);
  const [mensaje, setMensaje] = useState('');
  const [mensajeTipo, setMensajeTipo] = useState(''); // 'success', 'error', 'info'

  useEffect(() => {
    if (user) {
      cargarPremios();
    }
 }, [user]);

  const cargarPremios = async () => {
    if (!user) return;

    try {
      setLoadingPremios(true);
      const data = await obtenerPremiosUsuario();
      if (data.success) {
        setPremiosData(data);
      } else {
        setMensaje(data.message || 'Error al cargar los premios');
        setMensajeTipo('error');
      }
    } catch (error) {
      console.error('Error al cargar los premios:', error);
      setMensaje('Error de conexión al cargar los premios');
      setMensajeTipo('error');
    } finally {
      setLoadingPremios(false);
    }
  };

  const manejarReclamarPremioDiario = async () => {
    try {
      const response = await reclamarPremioDiario();
      if (response.success) {
        setMensaje(response.message);
        setMensajeTipo('success');
        // Recargar los datos de premios
        cargarPremios();
      } else {
        setMensaje(response.message);
        setMensajeTipo('error');
      }
    } catch (error) {
      console.error('Error al reclamar premio diario:', error);
      setMensaje('Error de conexión al reclamar el premio diario');
      setMensajeTipo('error');
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded relative dark:bg-yellow-900 dark:border-yellow-700 dark:text-yellow-200" role="alert">
        <strong className="font-bold">No autenticado: </strong>
        <span className="block sm:inline">Por favor, inicia sesión para ver tus premios.</span>
      </div>
    );
  }

  if (loadingPremios) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  const { usuario, premios_usuario, premios_pendientes } = premiosData || {};

  // Ocultar premios a todo el mundo
  return null; // No renderizar nada para nadie
};

export default PremiosUsuario;
